// import React from "react";
import { ProgressDocument } from "@cs/lib/models/progress.model";
import { ChapterId, FinalQuizId } from "@cs/lib/models/skeleton.model";
import { User } from "@firebase/auth";
import { doc, getFirestore, updateDoc } from "@firebase/firestore";
import { timestamp } from "./timestamp";

export type UpdateChapterStateAction = {
  action: 'updateChapterState',
  args: UpdateChapterStateArgs
}

type UpdateChapterStateArgs = {
  done: boolean,
  courseId: string,
  chapterId: ChapterId | FinalQuizId,
}

// Set the chapter state to done or not done
export function updateChapterState({
  done,
  courseId,
  chapterId,
  user,
  setProgress
}: UpdateChapterStateArgs & {
  user?: User | null,
  setProgress: React.Dispatch<React.SetStateAction<ProgressDocument>>
}): Promise<void> {
  if (!user) {
    setProgress(progress => ({
      ...progress,
      [`${courseId}-${chapterId}`]: {
        ...progress[`${courseId}-${chapterId}`],
        state: {
          ...progress[`${courseId}-${chapterId}`]?.state,
          done
        }
      }
    }))
    return Promise.resolve()
  } else {
    return new Promise((resolve, reject) => {
      updateDoc(doc(getFirestore(), 'Progress', user.uid), {
        [`${courseId}-${chapterId}.state.done`]: done,
        [`${courseId}-${chapterId}.timestamp`]: timestamp()
      }).then(() => {
        resolve()
      }).catch(err => {
        reject(err)
      })
    })
  }
}